/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetPersonHistoryListResponse } from '../models/GetPersonHistoryListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PersonHistoriesService {
    /**
     * Search and retrieve a list of person histories
     * Search for person histories in the system :
     * - **From**: Specify the start date of search.
     * - **To**: Specify the end date of search.
     * - **PageNumber**: Specify the page number for pagination (default: 1).
     * - **PageSize**: Specify the number of records per page (default: 10, maximum: 100).
     * @param personId
     * @param pageNumber
     * @param pageSize
     * @param from
     * @param to
     * @returns GetPersonHistoryListResponse The list has been found.
     * @throws ApiError
     */
    public static getPersonHistoryListEndpoint(
        personId: string,
        pageNumber: number,
        pageSize: number,
        from?: string | null,
        to?: string | null,
    ): CancelablePromise<GetPersonHistoryListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/persons/{personId}/histories',
            path: {
                'personId': personId,
            },
            query: {
                'from': from,
                'to': to,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
}
